export const DOC_SIZE = {
  width: 72,
  height: 92,
  radius: 10,
} as const;

export const SCORE_PER_SIGN = 10;

export const SPAWN_INTERVAL_START_MS = 1600;
export const SPAWN_INTERVAL_END_MS = 550;
export const SPAWN_RAMP_DURATION_MS = 60_000;

export const PEN_TRAIL_MAX_POINTS = 18;

// Game over triggers when this many unsigned docs exist simultaneously.
export const MAX_UNSIGNED_ON_SCREEN = 6;

// Shard "explosion" tuning — docs shatter into this many pieces on sign,
// which fly outward with gravity + spin and fade over SHARD_LIFETIME_MS.
export const SHARD_COUNT = 6;
export const SHARD_LIFETIME_MS = 600;
export const SHARD_INITIAL_SPEED = 4; // CSS px per 16.67ms tick
export const SHARD_UPWARD_BIAS = 2.5;
export const SHARD_GRAVITY = 0.35; // per tick
export const SHARD_ANGULAR_RANGE = 0.25;

export const PHYSICS = {
  gravity: 0.6,
  friction: 0.8,
  restitution: 0.05,
  density: 0.002,
  frictionAir: 0.015,
  spawnVyMin: 0.4,
  spawnVyMax: 1.1,
  spawnVxRange: 0.35,
  spawnAngularRange: 0.025,
} as const;

export const COLORS = {
  primary: '#35B89B',
  gameOverRed: '#C0370F',
  docFill: '#F4F4F4',
  docStroke: '#E8E8E8',
  docBars: '#D4D4D4',
} as const;
